// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';



const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
window.dataLayer = window.dataLayer || [];
const marketing = localStorage.getItem('marketingConsent');
if (marketing !== null) {
  window.dataLayer.push({
    event: 'cookie_consent_init',
    marketingConsent: marketing === 'true'
  }); }
root.render(<App />);

